import { render, staticRenderFns } from "./DeptRoleAuthModal.vue?vue&type=template&id=642e9f1c&scoped=true"
import script from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleAuthModal.vue?vue&type=style&index=0&id=642e9f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e9f1c",
  null
  
)

export default component.exports